import cls from './password.module.scss';
import { Col, Form, Row } from 'react-bootstrap';
import { Icon, Button } from 'lb-components';
import { PromoIcon } from '../../../../assets/icons/menu';
import { EyeIcon, EyeSlashIcon } from '../../../../assets/icons';
import React, { memo, useState } from 'react';
import { Api, Toast, useTranslation } from 'lb-store';

const ChangePassword = ({ route, setRoute, navigate }) => {
  const {t}= useTranslation()
  const [form, setForm] = useState({
    oldPassword: {
      value: '',
      type: 'password',
    },
    newPassword: {
      value: '',
      type: 'password',
    },
    repeatPassword: {
      value: '',
      type: 'password',
    },
  });
  const submitHandler = (e) => {
    e.preventDefault();
    Api.User.ResetPassword({
      passwordOld: e.target.oldPassword.value,
      passwordNew: e.target.newPassword.value,
      passwordConfirm: e.target.repeatPassword.value,
    }).then((res) => {
      Toast.show({
        type: res.data.status && res.data.status === 1 ? 'success' : 'error',
        content:
          res.data.status && res.data.status === 1
            ? t('პაროლი წარმატებით შეიცვალა')
            : res.data.desc,
        autoClose: res.data.res === 'yes' ? 5000 : false,
        progress: res.data.res === 'yes' ? undefined : 100,
      });
      if (res.data.status && res.data.status === 1) {
        e.target.reset();
      }
      /*if (res.data?.res) {
        Toast.show({
          type: res.data.res === 'yes' ? 'success' : 'error',
          content:
            res.data.res === 'yes'
              ? t('პაროლი წარმატებით შეიცვალა')
              : res.data.errors,
          autoClose: res.data.res === 'yes' ? 5000 : false,
          progress: res.data.res === 'yes' ? undefined : 100,
        });
        if (res.data?.res === 'yes') {
          e.target.reset();
        }
      }*/
    });
  };
  return (
    <div className={cls.promoPage}>
      <div className={cls.description} style={{ paddingBottom: 0 }}>
        {t("რეკომენდაცია უსაფრთხოებისთვის")}
      </div>
      <div className={cls.description}>
        {t("გამოიყენეთ დიდი და პატარა ლათინური ასოების,ციფრებისა და სიმბოლოების კომბინაცია")}
      </div>
      <div className={cls.promoInput}>
        <Form className={cls.form} noValidate onSubmit={submitHandler}>
          <Form.Group style={{ position: 'relative' }}>
            <Form.Label>{t("ძველი პაროლი")}</Form.Label>
            <Form.Control
              type={form.oldPassword.type}
              name={'oldPassword'}
              className={cls.input}
            />
            <Icon
              Icon={
                form.oldPassword.type === 'password' ? EyeSlashIcon : EyeIcon
              }
              classname={cls.icon}
              onClick={() =>
                setForm({
                  ...form,
                  oldPassword: {
                    ...form.oldPassword,
                    type:
                      form.oldPassword.type === 'password'
                        ? 'text'
                        : 'password',
                  },
                })
              }
            />
          </Form.Group>
          <Form.Group style={{ position: 'relative' }}>
            <Form.Label>{t("ახალი პაროლი")}</Form.Label>
            <Form.Control
              type={form.newPassword.type}
              name={'newPassword'}
              className={cls.input}
            />
            <Icon
              Icon={
                form.newPassword.type === 'password' ? EyeSlashIcon : EyeIcon
              }
              classname={cls.icon}
              onClick={() =>
                setForm({
                  ...form,
                  newPassword: {
                    ...form.newPassword,
                    type:
                      form.newPassword.type === 'password'
                        ? 'text'
                        : 'password',
                  },
                })
              }
            />
          </Form.Group>
          <Form.Group style={{ position: 'relative' }}>
            <Form.Label>{t("გაიმეორეთ პაროლი")}</Form.Label>
            <Form.Control
              type={form.repeatPassword.type}
              name={'repeatPassword'}
              className={cls.input}
            />
            <Icon
              Icon={
                form.repeatPassword.type === 'password' ? EyeSlashIcon : EyeIcon
              }
              classname={cls.icon}
              onClick={() =>
                setForm({
                  ...form,
                  repeatPassword: {
                    ...form.repeatPassword,
                    type:
                      form.repeatPassword.type === 'password'
                        ? 'text'
                        : 'password',
                  },
                })
              }
            />
          </Form.Group>
          <Row style={{ margin: '2rem 0 0' }}>
            <Col style={{ textAlign: 'right', margin: 0, padding: 0 }}>
              <Button variant='success' type='submit' className={cls.button}>
                {t("შენახვა")}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};
export default memo(ChangePassword);
